module.exports = {"id":"236791","name":"Antonín Barák","rating":"77","photo":"./data/images/photos/2/236791.png","club":{"name":"Udinese","logo":"./data/images/clubs/Udinese.png"},"positions":["MC","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AntoninBarak0.json
// module id = 435
// module chunks = 0